"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PinnedEntity = void 0;
var classroom_1 = require("./classroom/classroom");
var collection_1 = require("./collection/collection");
var content_1 = require("./content");
var enums_1 = require("./enums");
var meeting_1 = require("./meeting/meeting");
var subject_1 = require("./subject");
var FavoriteEntityProperties = ['id', 'title', 'type', 'owner_id', 'image', 'image_id', 'entity', 'entity_id', 'created_at', 'updated_at'];
var PinnedEntity = /** @class */function () {
  function PinnedEntity(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = FavoriteEntityProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    return instance;
  }
  PinnedEntity.prototype.getEntity = function () {
    if (!this.entity) {
      return null;
    }
    switch (this.type) {
      case enums_1.EntityTypeEnum.collection:
        this.entity = new collection_1.Collection(this.entity);
        break;
      case enums_1.EntityTypeEnum.content:
        this.entity = new content_1.Content(this.entity);
        break;
      case enums_1.EntityTypeEnum.meeting:
        this.entity = new meeting_1.Meeting(this.entity);
        break;
      case enums_1.EntityTypeEnum.subject:
        this.entity = new subject_1.Subject(this.entity);
        break;
      case enums_1.EntityTypeEnum.classroom:
        this.entity = new classroom_1.Classroom(this.entity);
        break;
    }
    return this.entity;
  };
  return PinnedEntity;
}();
exports.PinnedEntity = PinnedEntity;
